import { FIELD_TYPES } from "../constants/field-types.js";
const hasMultilineAddress = (form) => {
  return Boolean(
    [...form?.fields || [], ...form?.deletedFields || []].some(
      (field) => field.view?.fieldType === FIELD_TYPES.MULTILINE_ADDRESS || field.view?.fieldType === FIELD_TYPES.BOOKINGS_ADDRESS
    )
  );
};
const isMultilineAddressField = (field) => field.view?.fieldType === FIELD_TYPES.MULTILINE_ADDRESS || field.view?.fieldType === FIELD_TYPES.BOOKINGS_ADDRESS;
export {
  hasMultilineAddress,
  isMultilineAddressField
};
//# sourceMappingURL=multiline-address.js.map
